// removed by extract-text-webpack-plugin
module.exports = {"container":"CinYi"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor/text-editor-toolbar.scss
// module id = 811
// module chunks = 3 4 5 6 7